//Library modul
import { useEffect } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";

//Personal Component
import Login from "../../Components/auth/Login";
import NavigationLanding from "../../Components/layout/NavigationLanding";

//General Function
import dict from "../../Data/dict.json";
import LandingAuth from "../../Components/layout/LandingAuth";
import domain_list from "../../Data/domain_list";

const LandingLogin = ({ auth }) => {
  const history = useHistory();

  useEffect(() => {
    const token_mapid = localStorage.getItem("token_mapid");
    const mapid_user = localStorage.getItem("mapid_user");

    if (token_mapid && mapid_user) {
      history.push("/dashboard");
    }
  }, [history]);

  const get_register_link = () => {
    const params = new URLSearchParams(window.location.search);
    const params_str = params.toString();
    let reg_link = "/register";
    if (params_str) reg_link = `/register?${params_str}`;
    return reg_link;
  };

  const language = localStorage?.language ? localStorage?.language : "ina";
  const domain = auth.domain;
  const domain_w_port = window.location.host;
  const is_login_kai = domain_list?.[domain_w_port]?.is_login_kai;

  const reg_link = get_register_link();

  const itemContent = (
    <div className="box_content">
      <div className="flex flex_col gap_10">
        <h1> {dict["Sign in"][language]}</h1>
        <p>
          {
            dict["Sign in to your account and enjoy the exclusive features."][
              language
            ]
          }
        </p>
      </div>
      <Login isNav={false} />
      {!is_login_kai && (
        <div className="box_content_bottom">
          <p className="button_account">
            {dict["Don't have an account?"][language]}
          </p>
          <Link
            to={reg_link}
            className="button_register text_black bold"
            data-mapid="clickRegister"
          >
            {dict["Sign up"][language]}
          </Link>
        </div>
      )}
    </div>
  );

  return (
    <LandingAuth
      nav={<NavigationLanding />}
      title={domain_list?.[domain]?.title}
      subtitle={domain_list?.[domain]?.sub_title}
      content={itemContent}
    />
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(LandingLogin);
